// extracted by mini-css-extract-plugin
export var button = "Intro-module--button--b4b57";
export var buttonWrapper = "Intro-module--buttonWrapper--a3ce4";
export var container = "Intro-module--container--26e4e";
export var content = "Intro-module--content--10b94";
export var copy = "Intro-module--copy--f5b62";
export var heading = "Intro-module--heading--0e4c6";
export var intro = "Intro-module--intro--22296";
export var stat = "Intro-module--stat--8d033";
export var statMetric = "Intro-module--statMetric--b1dd4";
export var statUnit = "Intro-module--statUnit--4f76c";
export var stats = "Intro-module--stats--5092c";